import API from "../../api/api";

const callGetApi = async (endpoint, params) => {
  try {
    const response = await API.get(endpoint, { params });
    if (response.status === 200) {
      return response.data;
    } else {
      return response;
    }
  } catch (error) {
    throw error;
  }
};

const NetworkAnalyticsService = {
  getOverview: async (startDate, endDate) => {
    return callGetApi("network-analytics/overview", { startDate, endDate });
  },
  getLegs: async (startDate, endDate) => {
    return callGetApi("network-analytics/legs", { startDate, endDate });
  },
  getSalesAnalytics: async (startDate, endDate, legId) => {
    return callGetApi("network-analytics/sales-analytics", {
      startDate,
      endDate,
      legId: legId || "",
    });
  },
  getSales: async (startDate, endDate, legId, page, pageSize) => {
    return callGetApi("network-analytics/sales", {
      startDate,
      endDate,
      legId: legId || "",
      page: page || 1,
      pageSize: pageSize || 20,
    });
  },
  getProducts: async (startDate, endDate, legId, page, pageSize) => {
    return callGetApi("network-analytics/products", {
      startDate,
      endDate,
      legId: legId || "",
      page: page || 1,
      pageSize: pageSize || 20,
    });
  },
  getTopPerformers: async (startDate, endDate, legId, limit) => {
    return callGetApi("network-analytics/top-performers", {
      startDate,
      endDate,
      legId: legId || "",
      limit: limit || 10,
    });
  },
  getLegDetails: async (legId, startDate, endDate, page, pageSize, sortBy) => {
    return callGetApi(`network-analytics/leg-details/${legId}`, {
      startDate,
      endDate,
      page: page || 1,
      pageSize: pageSize || 20,
      sortBy: sortBy || 'directSales',
    });
  },
};

export default NetworkAnalyticsService;
